import React from 'react';
import {
    getStaffRegisterRepo, postStaffRegisterRepo
} from "../repositories/premium/permission";
import { createSlice } from "@reduxjs/toolkit";

const StaffRegisterSlice = createSlice({
    name: "staffRegisterReducer",
    initialState: {
        staffRegisterLoading: null,
        staffRegister: null,
        staffRegisterError: null,

        postStaffRegisterLoading: null,
        postStaffRegisterData: null,
        postStaffRegisterError: null,
        message: null
    },
    reducers: {
        getStaffRegisterLoading(state, action) {
            return {
                ...state,
                staffRegisterLoading: true,
            };
        },
        getStaffRegisterSuccess(state, action) {
            return {
                ...state,
                staffRegisterLoading: false,
                staffRegister: action.payload,
            };
        },
        getStaffRegisterFailure(state, action) {
            return {
                ...state,
                staffRegisterLoading: false,
                staffRegisterError: action.payload,
            };
        },
        getStaffRegisterClear(state, action) {
            return {
                ...state,
                staffRegister: null,
            };
        },
        postStaffRegisterLoading(state, action) {
            return {
                ...state,
                postStaffRegisterLoading: true,
                message: null
            };
        },
        postStaffRegisterSuccess(state, action) {
            return {
                ...state,
                postStaffRegisterLoading: false,
                postStaffRegisterData: action.payload,
                message: "Data Added Successfully"
            };
        },
        postStaffRegisterFailure(state, action) {
            return {
                ...state,
                postStaffRegisterLoading: false,
                postStaffRegisterError: action.payload,
                message: "Failure in Adding Data",
            };
        },
        postStaffRegisterClear(state, action) {
            return {
                ...state,
                message: null,
                postStaffRegisterError: null,
                postStaffRegisterData: null,
            };
        },
    },
});
export const {
    getStaffRegisterLoading,
    getStaffRegisterSuccess,
    getStaffRegisterFailure,
    getStaffRegisterClear,

    postStaffRegisterLoading,
    postStaffRegisterSuccess,
    postStaffRegisterFailure,
    postStaffRegisterClear
} = StaffRegisterSlice.actions;

export const getStaffRegister = (params) => {
    return async (dispatch) => {
        dispatch(getStaffRegisterLoading());
        await getStaffRegisterRepo(params)
            .then((response) => {
                if (
                    response?.status == 200 ||
                    response?.status == 201 ||
                    response?.status == 301
                ) {
                    dispatch(getStaffRegisterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getStaffRegisterFailure(error.message));
                }
            });
    };
};

export const postStaffRegister = (params) => {
    return async (dispatch) => {
        dispatch(postStaffRegisterLoading());
        await postStaffRegisterRepo(params)
            .then((response) => {
                if (
                    response?.status == 200 ||
                    response?.status == 201 ||
                    response?.status == 301
                ) {
                    dispatch(postStaffRegisterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postStaffRegisterFailure(error.message));
                }
            });
    };
};
export default StaffRegisterSlice.reducer;